export default "__VITE_ASSET__hNL7kD3f__"